<template>
    <span class="product-card-badge product-card-badge--bonus">+{{ bonusAccumulationAmount }} Бонусов накопим</span>
</template>
<script>

import {mapGetters} from "vuex";

export default {
    props: [
        'product'
    ],
    data() {
        return {
            bonusAmount: 0
        }
    },
    computed: {
        ...mapGetters('product', [
            'bonusAccumulationAmount'
        ])
    }

}
</script>
